import { SET_USER_NAME, ISetUserName } from "./authentication-types";

export const setUserName = (userName: string): ISetUserName => ({
    type: SET_USER_NAME,
    userName,
});
